import React from 'react';
import parse from 'html-react-parser';
import CtaButton from '../../ctaButton/ctaButton';
import useWindowDimensions from '../../../hooks/useWindowDimensions';
import styles from './heroCarouselCard.module.scss';
import { TABLET_MD_BREAKPOINT } from '../../../utils/util';
import { getResponsiveImageProps } from '../../../utils/optimizedContentfulImage';

function HeroCarouselCard({
  item,
  onCardClick,
  mailOfferContent,
  isFirstCard,
}) {
  const { width } = useWindowDimensions();
  const isMobile = width < TABLET_MD_BREAKPOINT;

  if (!item) {
    return null;
  }

  const { headlineImage, headline, promotion, ctaButton } = item;

  const hasMultiLinePromotion = promotion && promotion.includes('<br');

  const renderPromotion = () => {
    if (!promotion) return null;

    if (hasMultiLinePromotion) {
      const parts = promotion.split(/<br\s*\/?>/i);
      return (
        <p className={styles.promotion}>
          <span className={styles.promotionFirstLine}>{parse(parts[0])}</span>
          <span className={styles.promotionFirstLine}>
            {parse(parts[1] || '')}
          </span>
        </p>
      );
    }

    return <p className={styles.promotion}>{parse(promotion)}</p>;
  };

  const handleCTAClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (onCardClick && ctaButton?.label) {
      onCardClick(item, ctaButton.label);
    }
  };

  const handleCardClick = () => {
    if (onCardClick && ctaButton?.label) {
      onCardClick(item, ctaButton.label);
    }
  };

  const handleCardKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleCardClick();
    }
  };

  return (
    <div
      className={styles.carouselCard}
      onClick={handleCardClick}
      onKeyDown={handleCardKeyDown}
      role="button"
      tabIndex={0}
      aria-label={ctaButton?.label}
    >
      {headlineImage?.fields?.file?.url && (
        <img
          className={styles.cardBackground}
          {...getResponsiveImageProps(headlineImage.fields.file.url, {
            widths: [400, 800, 1200, 1600],
            sizes: '(max-width: 768px) 100vw, 992px',
          })}
          alt=""
          aria-hidden="true"
        />
      )}

      <div className={styles.cardOverlay} />

      <div className={styles.cardContent}>
        <div className={styles.headlineRow}>
          {headline && <h3 className={styles.headline}>{parse(headline)}</h3>}
        </div>
        <div className={styles.promotionRow}>
          <div className={styles.promotionWrapper}>{renderPromotion()}</div>
          {isMobile ? (
            <div className={styles.ctaAndMailWrapper}>
              {ctaButton && ctaButton.label && (
                <CtaButton
                  label={ctaButton.label}
                  href={ctaButton.link}
                  onClick={handleCTAClick}
                  variant="primary white"
                  size={width < TABLET_MD_BREAKPOINT ? 'xs' : 'lg'}
                />
              )}
              {mailOfferContent && isFirstCard && (
                <div className={styles.mailOfferWrapper}>
                  {mailOfferContent}
                </div>
              )}
            </div>
          ) : (
            ctaButton &&
            ctaButton.label && (
              <CtaButton
                label={ctaButton.label}
                href={ctaButton.link}
                onClick={handleCTAClick}
                variant="primary white"
                size={isMobile ? 'xs' : 'lg'}
              />
            )
          )}
        </div>
      </div>
    </div>
  );
}

export default HeroCarouselCard;
